export default __webpack_public_path__ + "static/media/moreInfo.3e85acdd.svg";